// src/helpers/rutaTesoreria.js
import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";
const API_BASE = process.env.REACT_APP_API || BASE_URL;

const api = axios.create({ baseURL: API_BASE, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  if (token) config.headers.token = token; // tu back usa 'token'
  return config;
});

const parseErr = (e) =>
  e?.response?.data?.msg ??
  e?.response?.data?.err ??
  e?.response?.data?.error ??
  e?.response?.data?.message ??
  e?.message ??
  "Error desconocido";

// probá primero /tesoreria (singular), si 404 → /tesorerias (plural)
const PATHS = ["/tesoreria", "/tesorerias"];

async function getWithFallback(subpath, params = {}) {
  let lastErr = null;
  for (const base of PATHS) {
    try {
      const { data } = await api.get(`${base}${subpath}`, { params });
      return data;
    } catch (e) {
      lastErr = e;
      if (e?.response?.status !== 404) return { ok: false, msg: parseErr(e) };
    }
  }
  return { ok: false, msg: parseErr(lastErr) || "Endpoint no encontrado (/tesoreria /tesorerias)" };
}

async function postWithFallback(subpath, body = {}) {
  let lastErr = null;
  for (const base of PATHS) {
    try {
      const { data } = await api.post(`${base}${subpath}`, body, {
        headers: { "Content-Type": "application/json" },
      });
      return data;
    } catch (e) {
      lastErr = e;
      if (e?.response?.status !== 404) return { ok: false, msg: parseErr(e) };
    }
  }
  return { ok: false, msg: parseErr(lastErr) || "Endpoint no encontrado (/tesoreria /tesorerias)" };
}

/** Resumen de saldos (cajas, cuentas, emitidos, etc.) */
export const getSaldosTesoreria = (params = {}) =>
  getWithFallback("/saldos", params);

/** Detalle de cheques / iCheq EMITIDOS (por OP) */
export const getEmitidosTesoreria = (params = {}) =>
  getWithFallback("/emitidos", params);

/** Detalle de valores RECIBIDOS (cartera) */
export const getRecibidosTesoreria = (params = {}) =>
  getWithFallback("/recibidos", params);

/** (Opcional) Recalcula y persiste saldosActual en cajas/cuentas (ADMIN) */
export const postRecalcularTesoreria = () =>
  postWithFallback("/recalcular", {});

// export por defecto
export default {
  getSaldosTesoreria,
  getEmitidosTesoreria,
  getRecibidosTesoreria,
  postRecalcularTesoreria,
};
